/**
 * Menu drawer — same open/close pattern as cart drawer
 */
(function () {
  const DRAWER_ID = 'Menu-Drawer';
  const TOGGLE_ID = 'menu-drawer-toggle';

  function getDrawer() {
    return document.getElementById(DRAWER_ID);
  }

  function getToggle() {
    return document.getElementById(TOGGLE_ID);
  }

  function placeDrawer() {
    const drawer = getDrawer();
    const wrapper = document.getElementById('wrapper');
    const clickCapture = wrapper?.querySelector('.click-capture');

    if (!drawer || !wrapper || !clickCapture) {
      return;
    }

    if (drawer.parentElement !== wrapper) {
      wrapper.insertBefore(drawer, clickCapture);
    }
  }

  function openDrawer() {
    const drawer = getDrawer();
    const toggle = getToggle();

    if (!drawer || !toggle) {
      return;
    }

    drawer.classList.add('active');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('open-cc');
    document.body.classList.add('open-menu-drawer');
    toggle.setAttribute('aria-expanded', 'true');
    drawer.querySelector('.menu-drawer__close')?.focus();
  }

  function closeDrawer() {
    const drawer = getDrawer();
    const toggle = getToggle();

    if (!drawer) {
      return;
    }

    drawer.querySelectorAll('.menu-drawer-nav__disclosure[open]').forEach((disclosure) => {
      disclosure.removeAttribute('open');
    });

    drawer.classList.remove('active');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('open-menu-drawer');
    toggle?.setAttribute('aria-expanded', 'false');

    if (!document.querySelector('.side-panel.active')) {
      document.body.classList.remove('open-cc');
    }
  }

  function initMenuAccordion() {
    const drawer = getDrawer();

    if (!drawer) {
      return;
    }

    drawer.querySelectorAll('.menu-drawer-nav__disclosure').forEach((disclosure) => {
      if (disclosure.dataset.accordionBound === 'true') {
        return;
      }

      disclosure.dataset.accordionBound = 'true';

      disclosure.addEventListener('toggle', () => {
        if (!disclosure.open) {
          return;
        }

        drawer.querySelectorAll('.menu-drawer-nav__disclosure[open]').forEach((other) => {
          if (other !== disclosure) {
            other.removeAttribute('open');
          }
        });
      });
    });
  }

  function onToggleClick(event) {
    const toggle = event.target.closest(`#${TOGGLE_ID}`);

    if (!toggle) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const drawer = getDrawer();

    if (drawer?.classList.contains('active')) {
      if (typeof dispatchCustomEvent === 'function') {
        dispatchCustomEvent('panel:close');
      } else {
        closeDrawer();
      }
    } else {
      openDrawer();
    }
  }

  function initMenuDrawer() {
    placeDrawer();
    closeDrawer();
    initMenuAccordion();
  }

  document.body.addEventListener('click', onToggleClick);
  document.addEventListener('panel:close', closeDrawer);
  document.addEventListener('DOMContentLoaded', initMenuDrawer);
  document.addEventListener('shopify:section:load', initMenuDrawer);

  if (document.readyState !== 'loading') {
    initMenuDrawer();
  }
})();
